module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("动态管理 / 带货商品详情")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.goodsList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品图片",
      "width": "160"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('img', {
            staticStyle: {
              "padding-top": "8px"
            },
            attrs: {
              "width": "100%",
              "src": _vm.row.imgUrl
            }
          })
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "商品地址",
      "width": "360"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "marketPrice",
      "label": "市场价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesPrice",
      "label": "销售价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "saleCount",
      "label": "销量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "商品状态"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f69dd6f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Dynamics/DynamicManage/GoodsDetail.vue
// module id = 1142
// module chunks = 0